<script setup>
import { watch } from 'vue';
import { useQuasar } from 'quasar';
import { UserService } from '@/services';
import { useStateStore } from '@/stores/state.store';
import Tr from '@/i18n/translation';

import { InputSelectMultiple, InputSelect } from '@/components/inputs';

import routeNames from '@/router/routeNames';

const props = defineProps({
  clientId: {
    type: String,
    required: true,
  },
});

const quasar = useQuasar();
const stateStore = useStateStore();
const eventNames = Object.values(routeNames);

watch(stateStore.getCommonData.eventsType, async () => {
  if (stateStore.getCommonData.eventsType.length === 0) {
    stateStore.getCommonData.defaultType = '';
  }
});

async function sendCommonData() {
  if (props.clientId) {
    const res = await UserService.sendCommonData(
      props.clientId,
      stateStore.getCommonData.eventDate,
      stateStore.getCommonData.eventsType,
      stateStore.getCommonData.defaultType,
      stateStore.getCommonData.langList,
      stateStore.getCommonData.isNewSender,
    );

    if (res) {
      quasar.notify({
        type: 'info',
        message: `Wysłano dane klienta`,
      });
    } else {
      quasar.notify({
        type: 'negative',
        message: `Błąd w przesyle danych`,
      });
    }
  } else {
    quasar.notify({
      type: 'negative',
      message: `Nie wybrano wszystkich pól`,
    });
  }
}
</script>

<template>
  <q-form ref="CommonForm" class="form" @submit.prevent="sendCommonData">
    <div class="send">
      <button class="core-default-form-button" type="submit">Wyślij</button>
    </div>
    <div class="inputs">
      <div class="input">
        <p class="label">Data</p>
        <q-input
          v-model="stateStore.getCommonData.eventDate"
          class="core-default-input-form"
          borderless
          type="date"
          lazy-rules
          :rules="[(val) => !!val || 'To pole nie może być puste']"
        />
      </div>
      <div class="input">
        <InputSelectMultiple
          v-model="stateStore.getCommonData.eventsType"
          :select-options="eventNames"
          class="input"
          main-color="#84491f"
          background-color="#fffbf8"
          text-font="Raleway"
          >Wybierz produkty klienta</InputSelectMultiple
        >
      </div>
      <div class="input">
        <InputSelect
          v-model="stateStore.getCommonData.defaultType"
          class="input"
          :select-options="stateStore.getCommonData.eventsType"
          main-color="#84491f"
          background-color="#fffbf8"
          text-font="Raleway"
          auto-default
          >Domyślny produkt</InputSelect
        >
      </div>
      <div class="input">
        <InputSelectMultiple
          v-model="stateStore.getCommonData.langList"
          :select-options="Tr.supportedLocales"
          class="input"
          main-color="#84491f"
          background-color="#fffbf8"
          text-font="Raleway"
          >Wybierz języki aplikacji</InputSelectMultiple
        >
      </div>
      <div class="input">
        <p class="label">Czy nowy sender</p>
        <Checkbox v-model="stateStore.getCommonData.isNewSender" binary />
      </div>
    </div>
  </q-form>
</template>

<style lang="scss" scoped>
@import './form';

.form .inputs {
  grid-template-columns: 1fr;
}
</style>
